export const ASSETS = "/assets";
// export const SITE_URL = "http://localhost:3001";
export const SITE_URL = typeof window !== "undefined" ? (process.env.NODE_ENV !== 'production' ?  "http://localhost:3001": window.location.origin) : "http://sustainability.unlutekstil.com.tr/";